import React, {useState} from "react";
import TopBar from "../globalComponents/topbar";
import Footer from "../globalComponents/footer";
export default (props) => {
	const [input1, onChangeInput1] = useState('');
	const [input2, onChangeInput2] = useState('');
	return (
		<div 
			style={{
				display: "flex",
				flexDirection: "column",
				background: "#FFFFFF",
			}}>
			<div 
				style={{
					height: 1400,
					alignSelf: "stretch",
					background: "#F6F7F9",
				}}>
				<div 
					style={{
						alignSelf: "stretch",
						display: "flex",
						flexDirection: "column",
						alignItems: "flex-start",
						paddingBottom: 92,
					}}>
					<div 
						style={{
							display: "flex",
							flexDirection: "column",
							alignItems: "flex-start",
							position: "relative",
						}}>
					
						<div 
							style={{
								position: "absolute",
								top: 211,
								left: 0,
								width: 236,
								height: 1,
								background: "#E6E6E6",
							}}>
						</div>
					</div>
					{/* <div 
						style={{
							display: "flex",
							alignItems: "center",
							background: "#FFFFFF",
							paddingTop: 20,
							paddingBottom: 20,
							paddingLeft: 33,
							paddingRight: 33,
							marginBottom: 32,
							marginLeft: 234,
						}}>
						<div 
							style={{
								flexShrink: 0,
								display: "flex",
								alignItems: "center",
								background: "#F6F7F9",
								borderRadius: 8,
								paddingTop: 14,
								paddingBottom: 14,
								paddingLeft: 20,
								paddingRight: 20,
								marginRight: 257,
								gap: 12,
							}}>
							<img
								src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/2l6e2b93_expires_30_days.png"} 
								style={{
									width: 21,
									height: 21,
									objectFit: "fill",
								}}
							/>
							<input
								placeholder={"For quick access to courses, mentors, or posts"}
								value={input1}
								onChange={(event)=>onChangeInput1(event.target.value)}
								style={{
									color: "#6C6C6C",
									fontSize: 14,
									width: 306,
									background: "none",
									border: "none",
									paddingTop: 2,
									paddingBottom: 2,
								}}
							/>
						</div>
						<div 
							style={{
								flexShrink: 0,
								display: "flex",
								alignItems: "center",
								background: "#FEF0E9",
								borderRadius: 8,
								paddingTop: 10,
								paddingBottom: 10,
								paddingLeft: 20,
								paddingRight: 23,
								marginRight: 32,
								gap: 8,
							}}>
							<img
								src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/hga4lsek_expires_30_days.png"} 
								style={{
									width: 32,
									height: 32,
									objectFit: "fill",
								}}
							/>
							<span 
								style={{
									color: "#F57E47",
									fontSize: 17,
									fontWeight: "bold",
								}} >
								{"Ask Giia"}
							</span>
						</div>
						<div 
							style={{
								width: 1,
								height: 58,
								background: "#E6E6E6",
								marginRight: 31,
							}}>
						</div>
						<img
							src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/dx0r2rm4_expires_30_days.png"} 
							style={{
								width: 24,
								height: 24,
								marginRight: 24,
								objectFit: "fill",
							}}
						/>
						<img
							src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/t96pmozk_expires_30_days.png"} 
							style={{
								width: 24,
								height: 24,
								objectFit: "fill",
							}}
						/>
					</div> */}
					<TopBar/>
					<span 
						style={{
							color: "#010101",
							fontSize: 40,
							fontWeight: "bold",
							marginLeft: 267,
						}} >
						{"Downloads"}
					</span>
					<div 
						style={{
							alignSelf: "stretch",
							display: "flex",
							flexDirection: "column",
							alignItems: "flex-end",
							marginBottom: 38,
						}}>
						<span 
							style={{
								color: "#6C6C6C",
								fontSize: 18,
								marginRight: 35,
							}} >
							{"Explore all resources"}
						</span>
					</div>
					<div 
						style={{
							display: "flex",
							alignItems: "flex-start",
							background: "#FFFFFF",
							borderRadius: 12,
							paddingLeft: 20,
							marginLeft: 267,
							boxShadow: "0px 1px 3px #00000003",
						}}>
						<div 
							style={{
								flexShrink: 0,
								display: "flex",
								flexDirection: "column",
								alignItems: "flex-start",
								marginTop: 20,
								marginRight: 44,
							}}>
							<span 
								style={{
									color: "#979797",
									fontSize: 16,
									fontWeight: "bold",
									marginBottom: 15,
								}} >
								{"Downloads Resources"}
							</span>
							<div 
								style={{
									width: 752,
									height: 1,
									background: "#E6E6E6",
									marginBottom: 16,
								}}>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									background: "#FAFAFA",
									borderRadius: 8,
									border: `1px solid #E6E6E6`,
									paddingTop: 12,
									paddingBottom: 12,
									paddingLeft: 33,
									paddingRight: 387,
									marginBottom: 16,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/pyo4nrsm_expires_30_days.png"} 
									style={{
										width: 21,
										height: 21,
										objectFit: "fill",
									}}
								/>
								<input
									placeholder={"Search resources..."}
									value={input2}
									onChange={(event)=>onChangeInput2(event.target.value)}
									style={{
										color: "#6C6C6C",
										fontSize: 14,
										width: 124,
										background: "none",
										border: "none",
										paddingTop: 2,
										paddingBottom: 2,
									}}
								/>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "flex-start",
									marginBottom: 16,
									gap: 12,
								}}>
								<button 
									style={{
										flexShrink: 0,
										display: "flex",
										flexDirection: "column",
										alignItems: "flex-start",
										background: "linear-gradient(180deg, #6BD0F6, #00AEEF)",
										borderRadius: 4,
										border: "none",
										paddingTop: 6,
										paddingBottom: 6,
										paddingLeft: 12,
										paddingRight: 12,
										textAlign: "left",
									}}
									onClick={()=>alert("Pressed!")}>
									<span 
										style={{
											color: "#FFFFFF",
											fontSize: 12,
											fontWeight: "bold",
										}} >
										{"All"}
									</span>
								</button>
								<button 
									style={{
										flexShrink: 0,
										display: "flex",
										flexDirection: "column",
										alignItems: "flex-start",
										background: "#FFFFFF",
										borderRadius: 4,
										border: `1px solid #E6E6E6`,
										paddingTop: 6,
										paddingBottom: 6,
										paddingLeft: 12,
										paddingRight: 12,
										textAlign: "left",
									}}
									onClick={()=>alert("Pressed!")}>
									<span 
										style={{
											color: "#979797",
											fontSize: 12,
										}} >
										{"Articles"}
									</span>
								</button>
								<button 
									style={{
										flexShrink: 0,
										display: "flex",
										flexDirection: "column",
										alignItems: "flex-start",
										background: "#FFFFFF",
										borderRadius: 4,
										border: `1px solid #E6E6E6`,
										paddingTop: 6,
										paddingBottom: 6,
										paddingLeft: 12,
										paddingRight: 12,
										textAlign: "left",
									}}
									onClick={()=>alert("Pressed!")}>
									<span 
										style={{
											color: "#979797",
											fontSize: 12,
										}} >
										{"Videos"}
									</span>
								</button>
								<button 
									style={{
										flexShrink: 0,
										display: "flex",
										flexDirection: "column",
										alignItems: "flex-start",
										background: "#FFFFFF",
										borderRadius: 4,
										border: `1px solid #E6E6E6`,
										paddingTop: 6,
										paddingBottom: 6,
										paddingLeft: 12,
										paddingRight: 12,
										textAlign: "left",
									}}
									onClick={()=>alert("Pressed!")}>
									<span 
										style={{
											color: "#979797",
											fontSize: 12,
										}} >
										{"Templates"}
									</span>
								</button>
								<button 
									style={{
										flexShrink: 0,
										display: "flex",
										flexDirection: "column",
										alignItems: "flex-start",
										background: "#FFFFFF",
										borderRadius: 4,
										border: `1px solid #E6E6E6`,
										paddingTop: 6,
										paddingBottom: 6,
										paddingLeft: 12,
										paddingRight: 12,
										textAlign: "left",
									}}
									onClick={()=>alert("Pressed!")}>
									<span 
										style={{
											color: "#979797",
											fontSize: 12,
										}} >
										{"Case Studies & Reports"}
									</span>
								</button>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "flex-start",
									marginBottom: 20,
									gap: 28,
								}}>
								<div 
									style={{
										flexShrink: 0,
										display: "flex",
										flexDirection: "column",
										alignItems: "flex-start",
										background: "#FFFFFF",
										borderRadius: 12,
										border: `1px solid #E6E6E6`,
										paddingTop: 16,
										paddingBottom: 16,
									}}>
									<div 
										style={{
											display: "flex",
											alignItems: "center",
											marginBottom: 8,
											marginLeft: 16,
											marginRight: 16,
											gap: 12,
										}}>
										<div 
											style={{
												flexShrink: 0,
												display: "flex",
												flexDirection: "column",
												alignItems: "flex-start",
												paddingTop: 23,
												paddingBottom: 4,
												gap: 8,
												backgroundImage: 'url(https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/vow3qukk_expires_30_days.png)',
												backgroundSize: "cover",
												backgroundPosition: "center",
											}}>
											<div 
												style={{
													alignSelf: "stretch",
													display: "flex",
													flexDirection: "column",
													alignItems: "center",
												}}>
												<img
													src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/vozl58q0_expires_30_days.png"} 
													style={{
														width: 16,
														height: 16,
														objectFit: "fill",
													}}
												/>
											</div>
											<div 
												style={{
													display: "flex",
													alignItems: "center",
													paddingRight: 2,
													marginLeft: 25,
													gap: 2,
												}}>
												<img
													src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/5qty0tr7_expires_30_days.png"} 
													style={{
														width: 8,
														height: 8,
														objectFit: "fill",
													}}
												/>
												<span 
													style={{
														color: "#FFFFFF",
														fontSize: 8,
														fontWeight: "bold",
													}} >
													{"12:45"}
												</span>
											</div>
										</div>
										<div 
											style={{
												flexShrink: 0,
												display: "flex",
												flexDirection: "column",
												alignItems: "flex-start",
												marginTop: 4,
												marginBottom: 4,
												gap: 8,
											}}>
											<div 
												style={{
													display: "flex",
													alignItems: "center",
													gap: 39,
												}}>
												<span 
													style={{
														color: "#010101",
														fontSize: 14,
														fontWeight: "bold",
													}} >
													{"Market Research Strategies"}
												</span>
												<div 
													style={{
														flexShrink: 0,
														display: "flex",
														flexDirection: "column",
														alignItems: "flex-start",
														background: "linear-gradient(180deg, #F57E47, #F36421)",
														borderRadius: 2,
														paddingTop: 2,
														paddingBottom: 2,
														paddingLeft: 4,
														paddingRight: 4,
													}}>
													<span 
														style={{
															color: "#FFFFFF",
															fontSize: 8,
															fontWeight: "bold",
														}} >
														{"Video"}
													</span>
												</div>
											</div>
											<span 
												style={{
													color: "#6C6C6C",
													fontSize: 10,
													width: 247,
												}} >
												{"A step-by-step guide to conducting market research for your startup, including competitor analysis and customer insights."}
											</span>
										</div>
									</div>
									<span 
										style={{
											color: "#2C2C2C",
											fontSize: 10,
											fontWeight: "bold",
											marginBottom: 12,
											marginLeft: 89,
										}} >
										{"Duration: 12 min"}
									</span>
									<div 
										style={{
											display: "flex",
											alignItems: "flex-start",
											marginLeft: 16,
											marginRight: 16,
											gap: 12,
										}}>
										<div 
											style={{
												flexShrink: 0,
												display: "flex",
												alignItems: "flex-start",
												background: "#FFFFFF",
												borderRadius: 6,
												border: `1px solid #00000000`,
												paddingTop: 8,
												paddingBottom: 8,
												paddingLeft: 37,
												paddingRight: 39,
												gap: 4,
											}}>
											<img
												src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/zfd8u15k_expires_30_days.png"} 
												style={{
													width: 15,
													height: 15,
													objectFit: "fill",
												}}
											/>
											<span 
												style={{
													color: "#6BD0F6",
													fontSize: 12,
													fontWeight: "bold",
												}} >
												{"Watch Now"}
											</span>
										</div>
										<div 
											style={{
												flexShrink: 0,
												display: "flex",
												alignItems: "flex-start",
												background: "linear-gradient(180deg, #6BD0F6, #00AEEF)",
												borderRadius: 6,
												border: `1px solid #00000000`,
												paddingTop: 8,
												paddingBottom: 8,
												paddingLeft: 52,
												paddingRight: 55,
												gap: 4,
											}}>
											<img
												src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/0gn7du13_expires_30_days.png"} 
												style={{
													width: 15,
													height: 15,
													objectFit: "fill",
												}}
											/>
											<span 
												style={{
													color: "#FFFFFF",
													fontSize: 12,
													fontWeight: "bold",
												}} >
												{"Saved"}
											</span>
										</div>
									</div>
								</div>
								<div 
									style={{
										flexShrink: 0,
										display: "flex",
										flexDirection: "column",
										alignItems: "flex-start",
										background: "#FFFFFF",
										borderRadius: 12,
										border: `1px solid #E6E6E6`,
										paddingTop: 16,
										paddingBottom: 16,
									}}>
									<div 
										style={{
											display: "flex",
											alignItems: "center",
											marginBottom: 8,
											marginLeft: 16,
											marginRight: 16,
											gap: 12,
										}}>
										<div 
											style={{
												flexShrink: 0,
												display: "flex",
												flexDirection: "column",
												alignItems: "flex-start",
												paddingTop: 23,
												paddingBottom: 4,
												gap: 8,
												backgroundImage: 'url(https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/xgnf3uco_expires_30_days.png)',
												backgroundSize: "cover",
												backgroundPosition: "center",
											}}>
											<div 
												style={{
													alignSelf: "stretch",
													display: "flex",
													flexDirection: "column",
													alignItems: "center",
												}}>
												<img
													src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/6mp08xnb_expires_30_days.png"} 
													style={{
														width: 16,
														height: 16,
														objectFit: "fill",
													}}
												/>
											</div>
											<div 
												style={{
													display: "flex",
													alignItems: "center",
													paddingRight: 2,
													marginLeft: 25,
													gap: 2,
												}}>
												<img
													src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/k5ym4t8f_expires_30_days.png"} 
													style={{
														width: 8,
														height: 8,
														objectFit: "fill",
													}}
												/>
												<span 
													style={{
														color: "#FFFFFF",
														fontSize: 8,
														fontWeight: "bold",
													}} >
													{"12:45"}
												</span>
											</div>
										</div>
										<div 
											style={{
												flexShrink: 0,
												display: "flex",
												flexDirection: "column",
												alignItems: "flex-start",
												marginTop: 4,
												marginBottom: 4,
												gap: 8,
											}}>
											<div 
												style={{
													display: "flex",
													alignItems: "center",
													gap: 39,
												}}>
												<span 
													style={{
														color: "#010101",
														fontSize: 14,
														fontWeight: "bold",
													}} >
													{"Market Research Strategies"}
												</span>
												<div 
													style={{
														flexShrink: 0,
														display: "flex",
														flexDirection: "column",
														alignItems: "flex-start",
														background: "linear-gradient(180deg, #F57E47, #F36421)",
														borderRadius: 2,
														paddingTop: 2,
														paddingBottom: 2,
														paddingLeft: 4,
														paddingRight: 4,
													}}>
													<span 
														style={{
															color: "#FFFFFF",
															fontSize: 8,
															fontWeight: "bold",
														}} >
														{"Video"}
													</span>
												</div>
											</div>
											<span 
												style={{
													color: "#6C6C6C",
													fontSize: 10,
													width: 247,
												}} >
												{"A step-by-step guide to conducting market research for your startup, including competitor analysis and customer insights."}
											</span>
										</div>
									</div>
									<span 
										style={{
											color: "#2C2C2C",
											fontSize: 10,
											fontWeight: "bold",
											marginBottom: 12,
											marginLeft: 89,
										}} >
										{"Duration: 12 min"}
									</span>
									<div 
										style={{
											display: "flex",
											alignItems: "flex-start",
											marginLeft: 16,
											marginRight: 16,
											gap: 12,
										}}>
										<div 
											style={{
												flexShrink: 0,
												display: "flex",
												alignItems: "flex-start",
												background: "#FFFFFF",
												borderRadius: 6,
												border: `1px solid #00000000`,
												paddingTop: 8,
												paddingBottom: 8,
												paddingLeft: 37,
												paddingRight: 39,
												gap: 4,
											}}>
											<img
												src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/5c3howqp_expires_30_days.png"} 
												style={{
													width: 15,
													height: 15,
													objectFit: "fill",
												}}
											/>
											<span 
												style={{
													color: "#6BD0F6",
													fontSize: 12,
													fontWeight: "bold",
												}} >
												{"Watch Now"}
											</span>
										</div>
										<div 
											style={{
												flexShrink: 0,
												display: "flex",
												alignItems: "flex-start",
												background: "linear-gradient(180deg, #6BD0F6, #00AEEF)",
												borderRadius: 6,
												border: `1px solid #00000000`,
												paddingTop: 8,
												paddingBottom: 8,
												paddingLeft: 52,
												paddingRight: 55,
												gap: 4,
											}}>
											<img
												src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/7gh46obv_expires_30_days.png"} 
												style={{
													width: 15,
													height: 15,
													objectFit: "fill",
												}}
											/>
											<span 
												style={{
													color: "#FFFFFF",
													fontSize: 12,
													fontWeight: "bold",
												}} >
												{"Saved"}
											</span>
										</div>
									</div>
								</div>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "flex-start",
									marginBottom: 20,
									gap: 28,
								}}>
								<div 
									style={{
										flexShrink: 0,
										display: "flex",
										flexDirection: "column",
										alignItems: "flex-start",
										background: "#FFFFFF",
										borderRadius: 12,
										border: `1px solid #E6E6E6`,
										paddingTop: 16,
										paddingBottom: 16,
										gap: 16,
									}}>
									<div 
										style={{
											display: "flex",
											alignItems: "center",
											marginLeft: 16,
											marginRight: 16,
											gap: 12,
										}}>
										<img
											src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/odt3suih_expires_30_days.png"} 
											style={{
												width: 61,
												height: 61,
												objectFit: "fill",
											}}
										/>
										<div 
											style={{
												flexShrink: 0,
												display: "flex",
												flexDirection: "column",
												alignItems: "flex-start",
												gap: 8,
											}}>
											<div 
												style={{
													display: "flex",
													alignItems: "center",
													gap: 48,
												}}>
												<span 
													style={{
														color: "#010101",
														fontSize: 14,
														fontWeight: "bold",
													}} >
													{"Business Plan Template"}
												</span>
												<div 
													style={{
														flexShrink: 0,
														display: "flex",
														flexDirection: "column",
														alignItems: "flex-start",
														background: "linear-gradient(180deg, #F57E47, #F36421)",
														borderRadius: 2,
														paddingTop: 2,
														paddingBottom: 2,
														paddingLeft: 4,
														paddingRight: 4,
													}}>
													<span 
														style={{
															color: "#FFFFFF",
															fontSize: 8,
															fontWeight: "bold",
														}} >
														{"Template"}
													</span>
												</div>
											</div>
											<span 
												style={{
													color: "#6C6C6C",
													fontSize: 10,
													width: 252,
												}} >
												{"A structured business plan template to help you outline your vision, strategy, and financial projections."}
											</span>
										</div>
									</div>
									<div 
										style={{
											display: "flex",
											alignItems: "flex-start",
											marginLeft: 16,
											marginRight: 16,
											gap: 12,
										}}>
										<div 
											style={{
												flexShrink: 0,
												display: "flex",
												alignItems: "flex-start",
												background: "#FFFFFF",
												borderRadius: 6,
												border: `1px solid #00000000`,
												paddingTop: 8,
												paddingBottom: 8,
												paddingLeft: 27,
												paddingRight: 29,
												gap: 4,
											}}>
											<img
												src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/9npbqp8d_expires_30_days.png"} 
												style={{
													width: 15,
													height: 15,
													objectFit: "fill",
												}}
											/>
											<span 
												style={{
													color: "#6BD0F6",
													fontSize: 12,
													fontWeight: "bold",
												}} >
												{"View"}
											</span>
										</div>
										<div 
											style={{
												flexShrink: 0,
												display: "flex",
												alignItems: "flex-start",
												background: "#FFFFFF",
												borderRadius: 6,
												border: `1px solid #00000000`,
												paddingTop: 8,
												paddingBottom: 8,
												paddingLeft: 12,
												paddingRight: 13,
												gap: 4,
											}}>
											<img
												src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/mxhqmt90_expires_30_days.png"} 
												style={{
													width: 15,
													height: 15,
													objectFit: "fill",
												}}
											/>
											<span 
												style={{
													color: "#6BD0F6",
													fontSize: 12,
													fontWeight: "bold",
												}} >
												{"Bookmark"}
											</span>
										</div>
										<div 
											style={{
												flexShrink: 0,
												display: "flex",
												alignItems: "flex-start",
												background: "linear-gradient(180deg, #6BD0F6, #00AEEF)",
												borderRadius: 6,
												border: `1px solid #00000000`,
												paddingTop: 8,
												paddingBottom: 8,
												paddingLeft: 5,
												paddingRight: 7,
												gap: 4,
											}}>
											<img
												src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/u0ql5z1p_expires_30_days.png"} 
												style={{
													width: 15,
													height: 15,
													objectFit: "fill",
												}}
											/>
											<span 
												style={{
													color: "#FFFFFF",
													fontSize: 12,
													fontWeight: "bold",
												}} >
												{"Downloaded"}
											</span>
										</div>
									</div>
								</div>
								<div 
									style={{
										flexShrink: 0,
										display: "flex",
										flexDirection: "column",
										alignItems: "flex-start",
										background: "#FFFFFF",
										borderRadius: 12,
										border: `1px solid #E6E6E6`,
										paddingTop: 16,
										paddingBottom: 16,
										gap: 16,
									}}>
									<div 
										style={{
											display: "flex",
											alignItems: "center",
											marginLeft: 16,
											marginRight: 16,
											gap: 12,
										}}>
										<img
											src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/t7ez3ycg_expires_30_days.png"} 
											style={{
												width: 61,
												height: 61,
												objectFit: "fill",
											}}
										/>
										<div 
											style={{
												flexShrink: 0,
												display: "flex",
												flexDirection: "column",
												alignItems: "flex-start",
												gap: 8,
											}}>
											<div 
												style={{
													display: "flex",
													alignItems: "center",
													gap: 48,
												}}>
												<span 
													style={{
														color: "#010101",
														fontSize: 14,
														fontWeight: "bold",
													}} >
													{"Business Plan Template"}
												</span>
												<div 
													style={{
														flexShrink: 0,
														display: "flex",
														flexDirection: "column",
														alignItems: "flex-start",
														background: "linear-gradient(180deg, #F57E47, #F36421)",
														borderRadius: 2,
														paddingTop: 2,
														paddingBottom: 2,
														paddingLeft: 4,
														paddingRight: 4,
													}}>
													<span 
														style={{
															color: "#FFFFFF",
															fontSize: 8,
															fontWeight: "bold",
														}} >
														{"Template"}
													</span>
												</div>
											</div>
											<span 
												style={{
													color: "#6C6C6C",
													fontSize: 10,
													width: 252,
												}} >
												{"A structured business plan template to help you outline your vision, strategy, and financial projections."}
											</span>
										</div>
									</div>
									<div 
										style={{
											display: "flex",
											alignItems: "flex-start",
											marginLeft: 16,
											marginRight: 16,
											gap: 12,
										}}>
										<div 
											style={{
												flexShrink: 0,
												display: "flex",
												alignItems: "flex-start",
												background: "#FFFFFF",
												borderRadius: 6,
												border: `1px solid #00000000`,
												paddingTop: 8,
												paddingBottom: 8,
												paddingLeft: 27,
												paddingRight: 29,
												gap: 4,
											}}>
											<img
												src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/yrvoy24m_expires_30_days.png"} 
												style={{
													width: 15,
													height: 15,
													objectFit: "fill",
												}}
											/>
											<span 
												style={{
													color: "#6BD0F6",
													fontSize: 12,
													fontWeight: "bold",
												}} >
												{"View"}
											</span>
										</div>
										<div 
											style={{
												flexShrink: 0,
												display: "flex",
												alignItems: "flex-start",
												background: "#FFFFFF",
												borderRadius: 6,
												border: `1px solid #00000000`,
												paddingTop: 8,
												paddingBottom: 8,
												paddingLeft: 12,
												paddingRight: 13,
												gap: 4,
											}}>
											<img
												src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/bm64mawa_expires_30_days.png"} 
												style={{
													width: 15,
													height: 15,
													objectFit: "fill",
												}}
											/>
											<span 
												style={{
													color: "#6BD0F6",
													fontSize: 12,
													fontWeight: "bold",
												}} >
												{"Bookmark"}
											</span>
										</div>
										<div 
											style={{
												flexShrink: 0,
												display: "flex",
												alignItems: "flex-start",
												background: "linear-gradient(180deg, #6BD0F6, #00AEEF)",
												borderRadius: 6,
												border: `1px solid #00000000`,
												paddingTop: 8,
												paddingBottom: 8,
												paddingLeft: 5,
												paddingRight: 7,
												gap: 4,
											}}>
											<img
												src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/v0nxe65u_expires_30_days.png"} 
												style={{
													width: 15,
													height: 15,
													objectFit: "fill",
												}}
											/>
											<span 
												style={{
													color: "#FFFFFF",
													fontSize: 12,
													fontWeight: "bold",
												}} >
												{"Downloaded"}
											</span>
										</div>
									</div>
								</div>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "flex-start",
									marginBottom: 20,
									gap: 28,
								}}>
								<div 
									style={{
										flexShrink: 0,
										display: "flex",
										flexDirection: "column",
										alignItems: "flex-start",
										background: "#FFFFFF",
										borderRadius: 12,
										border: `1px solid #E6E6E6`,
										paddingTop: 16,
										paddingBottom: 16,
									}}>
									<div 
										style={{
											display: "flex",
											alignItems: "flex-start",
											marginBottom: 8,
											marginLeft: 16,
											marginRight: 16,
											gap: 12,
										}}>
										<div 
											style={{
												flexShrink: 0,
												display: "flex",
												flexDirection: "column",
												alignItems: "flex-start",
												paddingTop: 23,
												paddingBottom: 4,
												gap: 8,
												backgroundImage: 'url(https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/iglrkmo4_expires_30_days.png)',
												backgroundSize: "cover",
												backgroundPosition: "center",
											}}>
											<div 
												style={{
													alignSelf: "stretch",
													display: "flex",
													flexDirection: "column",
													alignItems: "center",
												}}>
												<img
													src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/4lc0j363_expires_30_days.png"} 
													style={{
														width: 16,
														height: 16,
														objectFit: "fill",
													}}
												/>
											</div>
											<div 
												style={{
													display: "flex",
													alignItems: "center",
													paddingRight: 2,
													marginLeft: 25,
													gap: 2,
												}}>
												<img
													src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/jq6a65mx_expires_30_days.png"} 
													style={{
														width: 8,
														height: 8,
														objectFit: "fill",
													}}
												/>
												<span 
													style={{
														color: "#FFFFFF",
														fontSize: 8,
														fontWeight: "bold",
													}} >
													{"10:45"}
												</span>
											</div>
										</div>
										<div 
											style={{
												flexShrink: 0,
												display: "flex",
												flexDirection: "column",
												alignItems: "flex-start",
												marginTop: 4,
												marginBottom: 4,
												gap: 8,
											}}>
											<div 
												style={{
													display: "flex",
													alignItems: "flex-start",
												}}>
												<span 
													style={{
														color: "#010101",
														fontSize: 14,
														fontWeight: "bold",
														marginRight: 66,
														width: 158,
													}} >
													{"How to Conduct Market Research"}
												</span>
												<div 
													style={{
														flexShrink: 0,
														display: "flex",
														flexDirection: "column",
														alignItems: "flex-start",
														background: "linear-gradient(180deg, #F57E47, #F36421)",
														borderRadius: 2,
														paddingTop: 2,
														paddingBottom: 2,
														paddingLeft: 4,
														paddingRight: 4,
														marginTop: 2,
													}}>
													<span 
														style={{
															color: "#FFFFFF",
															fontSize: 8,
															fontWeight: "bold",
														}} >
														{"Video"}
													</span>
												</div>
											</div>
											<span 
												style={{
													color: "#6C6C6C",
													fontSize: 10,
													width: 247,
												}} >
												{"A step-by-step guide to conducting market research for your startup, including competitor analysis and customer insights."}
											</span>
										</div>
									</div>
									<span 
										style={{
											color: "#2C2C2C",
											fontSize: 10,
											fontWeight: "bold",
											marginBottom: 12,
											marginLeft: 89,
										}} >
										{"Duration: 12 min"}
									</span>
									<div 
										style={{
											display: "flex",
											alignItems: "flex-start",
											marginLeft: 16,
											marginRight: 16,
											gap: 12,
										}}>
										<div 
											style={{
												flexShrink: 0,
												display: "flex",
												alignItems: "flex-start",
												background: "#FFFFFF",
												borderRadius: 6,
												border: `1px solid #00000000`,
												paddingTop: 8,
												paddingBottom: 8,
												paddingLeft: 37,
												paddingRight: 39,
												gap: 4,
											}}>
											<img
												src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/mxs6htcy_expires_30_days.png"} 
												style={{
													width: 15,
													height: 15,
													objectFit: "fill",
												}}
											/>
											<span 
												style={{
													color: "#6BD0F6",
													fontSize: 12,
													fontWeight: "bold",
												}} >
												{"Watch Now"}
											</span>
										</div>
										<div 
											style={{
												flexShrink: 0,
												display: "flex",
												alignItems: "flex-start",
												background: "linear-gradient(180deg, #6BD0F6, #00AEEF)",
												borderRadius: 6,
												border: `1px solid #00000000`,
												paddingTop: 8,
												paddingBottom: 8,
												paddingLeft: 52,
												paddingRight: 55,
												gap: 4,
											}}>
											<img
												src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/kl29nenr_expires_30_days.png"} 
												style={{
													width: 15,
													height: 15,
													objectFit: "fill",
												}}
											/>
											<span 
												style={{
													color: "#FFFFFF",
													fontSize: 12,
													fontWeight: "bold",
												}} >
												{"Saved"}
											</span>
										</div>
									</div>
								</div>
								<div 
									style={{
										flexShrink: 0,
										display: "flex",
										flexDirection: "column",
										alignItems: "flex-start",
										background: "#FFFFFF",
										borderRadius: 12,
										border: `1px solid #E6E6E6`,
										paddingTop: 16,
										paddingBottom: 16,
									}}>
									<div 
										style={{
											display: "flex",
											alignItems: "flex-start",
											marginBottom: 8,
											marginLeft: 16,
											marginRight: 16,
											gap: 12,
										}}>
										<div 
											style={{
												flexShrink: 0,
												display: "flex",
												flexDirection: "column",
												alignItems: "flex-start",
												paddingTop: 23,
												paddingBottom: 4,
												gap: 8,
												backgroundImage: 'url(https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/hlyoq4z9_expires_30_days.png)',
												backgroundSize: "cover",
												backgroundPosition: "center",
											}}>
											<div 
												style={{
													alignSelf: "stretch",
													display: "flex",
													flexDirection: "column",
													alignItems: "center",
												}}>
												<img
													src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/nekm2v63_expires_30_days.png"} 
													style={{
														width: 16,
														height: 16,
														objectFit: "fill",
													}}
												/>
											</div>
											<div 
												style={{
													display: "flex",
													alignItems: "center",
													paddingRight: 2,
													marginLeft: 25,
													gap: 2,
												}}>
												<img
													src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/iopzlhub_expires_30_days.png"} 
													style={{
														width: 8,
														height: 8,
														objectFit: "fill",
													}}
												/>
												<span 
													style={{
														color: "#FFFFFF",
														fontSize: 8,
														fontWeight: "bold",
													}} >
													{"10:45"}
												</span>
											</div>
										</div>
										<div 
											style={{
												flexShrink: 0,
												display: "flex",
												flexDirection: "column",
												alignItems: "flex-start",
												marginTop: 4,
												marginBottom: 4,
												gap: 8,
											}}>
											<div 
												style={{
													display: "flex",
													alignItems: "flex-start",
												}}>
												<span 
													style={{
														color: "#010101",
														fontSize: 14,
														fontWeight: "bold",
														marginRight: 66,
														width: 158,
													}} >
													{"How to Conduct Market Research"}
												</span>
												<div 
													style={{
														flexShrink: 0,
														display: "flex",
														flexDirection: "column",
														alignItems: "flex-start",
														background: "linear-gradient(180deg, #F57E47, #F36421)",
														borderRadius: 2,
														paddingTop: 2,
														paddingBottom: 2,
														paddingLeft: 4,
														paddingRight: 4,
														marginTop: 2,
													}}>
													<span 
														style={{
															color: "#FFFFFF",
															fontSize: 8,
															fontWeight: "bold",
														}} >
														{"Video"}
													</span>
												</div>
											</div>
											<span 
												style={{
													color: "#6C6C6C",
													fontSize: 10,
													width: 247,
												}} >
												{"A step-by-step guide to conducting market research for your startup, including competitor analysis and customer insights."}
											</span>
										</div>
									</div>
									<span 
										style={{
											color: "#2C2C2C",
											fontSize: 10,
											fontWeight: "bold",
											marginBottom: 12,
											marginLeft: 89,
										}} >
										{"Duration: 12 min"}
									</span>
									<div 
										style={{
											display: "flex",
											alignItems: "flex-start",
											marginLeft: 16,
											marginRight: 16,
											gap: 12,
										}}>
										<div 
											style={{
												flexShrink: 0,
												display: "flex",
												alignItems: "flex-start",
												background: "#FFFFFF",
												borderRadius: 6,
												border: `1px solid #00000000`,
												paddingTop: 8,
												paddingBottom: 8,
												paddingLeft: 37,
												paddingRight: 39,
												gap: 4,
											}}>
											<img
												src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/n1y5dezz_expires_30_days.png"} 
												style={{
													width: 15,
													height: 15,
													objectFit: "fill",
												}}
											/>
											<span 
												style={{
													color: "#6BD0F6",
													fontSize: 12,
													fontWeight: "bold",
												}} >
												{"Watch Now"}
											</span>
										</div>
										<div 
											style={{
												flexShrink: 0,
												display: "flex",
												alignItems: "flex-start",
												background: "linear-gradient(180deg, #6BD0F6, #00AEEF)",
												borderRadius: 6,
												border: `1px solid #00000000`,
												paddingTop: 8,
												paddingBottom: 8,
												paddingLeft: 52,
												paddingRight: 55,
												gap: 4,
											}}>
											<img
												src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/9yepqwk2_expires_30_days.png"} 
												style={{
													width: 15,
													height: 15,
													objectFit: "fill",
												}}
											/>
											<span 
												style={{
													color: "#FFFFFF",
													fontSize: 12,
													fontWeight: "bold",
												}} >
												{"Saved"}
											</span>
										</div>
									</div>
								</div>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "flex-start",
									gap: 28,
								}}>
								<div 
									style={{
										flexShrink: 0,
										display: "flex",
										flexDirection: "column",
										alignItems: "flex-start",
										background: "#FFFFFF",
										borderRadius: 12,
										border: `1px solid #E6E6E6`,
										paddingTop: 16,
										paddingBottom: 16,
									}}>
									<div 
										style={{
											display: "flex",
											alignItems: "center",
											marginBottom: 8,
											marginLeft: 16,
											marginRight: 16,
											gap: 12,
										}}>
										<div 
											style={{
												flexShrink: 0,
												display: "flex",
												flexDirection: "column",
												alignItems: "flex-start",
												paddingTop: 23,
												paddingBottom: 4,
												gap: 8,
												backgroundImage: 'url(https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/d8i1jwj6_expires_30_days.png)',
												backgroundSize: "cover",
												backgroundPosition: "center",
											}}>
											<div 
												style={{
													alignSelf: "stretch",
													display: "flex",
													flexDirection: "column",
													alignItems: "center",
												}}>
												<img
													src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/xhxb2que_expires_30_days.png"} 
													style={{
														width: 16,
														height: 16,
														objectFit: "fill",
													}}
												/>
											</div>
											<div 
												style={{
													display: "flex",
													alignItems: "center",
													paddingRight: 2,
													marginLeft: 25,
													gap: 2,
												}}>
												<img
													src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/24k5ag9c_expires_30_days.png"} 
													style={{
														width: 8,
														height: 8,
														objectFit: "fill",
													}}
												/>
												<span 
													style={{
														color: "#FFFFFF",
														fontSize: 8,
														fontWeight: "bold",
													}} >
													{"12:45"}
												</span>
											</div>
										</div>
										<div 
											style={{
												flexShrink: 0,
												display: "flex",
												flexDirection: "column",
												alignItems: "flex-start",
												marginTop: 4,
												marginBottom: 4,
												gap: 8,
											}}>
											<div 
												style={{
													display: "flex",
													alignItems: "center",
													gap: 39,
												}}>
												<span 
													style={{
														color: "#010101",
														fontSize: 14,
														fontWeight: "bold",
													}} >
													{"Market Research Strategies"}
												</span>
												<div 
													style={{
														flexShrink: 0,
														display: "flex",
														flexDirection: "column",
														alignItems: "flex-start",
														background: "linear-gradient(180deg, #F57E47, #F36421)",
														borderRadius: 2,
														paddingTop: 2,
														paddingBottom: 2,
														paddingLeft: 4,
														paddingRight: 4,
													}}>
													<span 
														style={{
															color: "#FFFFFF",
															fontSize: 8,
															fontWeight: "bold",
														}} >
														{"Video"}
													</span>
												</div>
											</div>
											<span 
												style={{
													color: "#6C6C6C",
													fontSize: 10,
													width: 247,
												}} >
												{"A step-by-step guide to conducting market research for your startup, including competitor analysis and customer insights."}
											</span>
										</div>
									</div>
									<span 
										style={{
											color: "#2C2C2C",
											fontSize: 10,
											fontWeight: "bold",
											marginBottom: 12,
											marginLeft: 89,
										}} >
										{"Duration: 12 min"}
									</span>
									<div 
										style={{
											display: "flex",
											alignItems: "flex-start",
											marginLeft: 16,
											marginRight: 16,
											gap: 12,
										}}>
										<div 
											style={{
												flexShrink: 0,
												display: "flex",
												alignItems: "flex-start",
												background: "#FFFFFF",
												borderRadius: 6,
												border: `1px solid #00000000`,
												paddingTop: 8,
												paddingBottom: 8,
												paddingLeft: 37,
												paddingRight: 39,
												gap: 4,
											}}>
											<img
												src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/r431rul0_expires_30_days.png"} 
												style={{
													width: 15,
													height: 15,
													objectFit: "fill",
												}}
											/>
											<span 
												style={{
													color: "#6BD0F6",
													fontSize: 12,
													fontWeight: "bold",
												}} >
												{"Watch Now"}
											</span>
										</div>
										<div 
											style={{
												flexShrink: 0,
												display: "flex",
												alignItems: "flex-start",
												background: "linear-gradient(180deg, #6BD0F6, #00AEEF)",
												borderRadius: 6,
												border: `1px solid #00000000`,
												paddingTop: 8,
												paddingBottom: 8,
												paddingLeft: 52,
												paddingRight: 55,
												gap: 4,
											}}>
											<img
												src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/asdd8evp_expires_30_days.png"} 
												style={{
													width: 15,
													height: 15,
													objectFit: "fill",
												}}
											/>
											<span 
												style={{
													color: "#FFFFFF",
													fontSize: 12,
													fontWeight: "bold",
												}} >
												{"Saved"}
											</span>
										</div>
									</div>
								</div>
								<div 
									style={{
										flexShrink: 0,
										display: "flex",
										flexDirection: "column",
										alignItems: "flex-start",
										background: "#FFFFFF",
										borderRadius: 12,
										border: `1px solid #E6E6E6`,
										paddingTop: 16,
										paddingBottom: 16,
									}}>
									<div 
										style={{
											display: "flex",
											alignItems: "center",
											marginBottom: 8,
											marginLeft: 16,
											marginRight: 16,
											gap: 12,
										}}>
										<div 
											style={{
												flexShrink: 0,
												display: "flex",
												flexDirection: "column",
												alignItems: "flex-start",
												paddingTop: 23,
												paddingBottom: 4,
												gap: 8,
												backgroundImage: 'url(https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/ic6dn9xf_expires_30_days.png)',
												backgroundSize: "cover",
												backgroundPosition: "center",
											}}>
											<div 
												style={{
													alignSelf: "stretch",
													display: "flex",
													flexDirection: "column",
													alignItems: "center",
												}}>
												<img
													src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/y5jley1p_expires_30_days.png"} 
													style={{
														width: 16,
														height: 16,
														objectFit: "fill",
													}}
												/>
											</div>
											<div 
												style={{
													display: "flex",
													alignItems: "center",
													paddingRight: 2,
													marginLeft: 25,
													gap: 2,
												}}>
												<img
													src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/kp1zztoh_expires_30_days.png"} 
													style={{
														width: 8,
														height: 8,
														objectFit: "fill",
													}}
												/>
												<span 
													style={{
														color: "#FFFFFF",
														fontSize: 8,
														fontWeight: "bold",
													}} >
													{"12:45"}
												</span>
											</div>
										</div>
										<div 
											style={{
												flexShrink: 0,
												display: "flex",
												flexDirection: "column",
												alignItems: "flex-start",
												marginTop: 4,
												marginBottom: 4,
												gap: 8,
											}}>
											<div 
												style={{
													display: "flex",
													alignItems: "center",
													gap: 39,
												}}>
												<span 
													style={{
														color: "#010101",
														fontSize: 14,
														fontWeight: "bold",
													}} >
													{"Market Research Strategies"}
												</span>
												<div 
													style={{
														flexShrink: 0,
														display: "flex",
														flexDirection: "column",
														alignItems: "flex-start",
														background: "linear-gradient(180deg, #F57E47, #F36421)",
														borderRadius: 2,
														paddingTop: 2,
														paddingBottom: 2,
														paddingLeft: 4,
														paddingRight: 4,
													}}>
													<span 
														style={{
															color: "#FFFFFF",
															fontSize: 8,
															fontWeight: "bold",
														}} >
														{"Video"}
													</span>
												</div>
											</div>
											<span 
												style={{
													color: "#6C6C6C",
													fontSize: 10,
													width: 247,
												}} >
												{"A step-by-step guide to conducting market research for your startup, including competitor analysis and customer insights."}
											</span>
										</div>
									</div>
									<span 
										style={{
											color: "#2C2C2C",
											fontSize: 10,
											fontWeight: "bold",
											marginBottom: 12,
											marginLeft: 89,
										}} >
										{"Duration: 12 min"}
									</span>
									<div 
										style={{
											display: "flex",
											alignItems: "flex-start",
											marginLeft: 16,
											marginRight: 16,
											gap: 12,
										}}>
										<div 
											style={{
												flexShrink: 0,
												display: "flex",
												alignItems: "flex-start",
												background: "#FFFFFF",
												borderRadius: 6,
												border: `1px solid #00000000`,
												paddingTop: 8,
												paddingBottom: 8,
												paddingLeft: 37,
												paddingRight: 39,
												gap: 4,
											}}>
											<img
												src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/abynjxo7_expires_30_days.png"} 
												style={{
													width: 15,
													height: 15,
													objectFit: "fill",
												}}
											/>
											<span 
												style={{
													color: "#6BD0F6",
													fontSize: 12,
													fontWeight: "bold",
												}} >
												{"Watch Now"}
											</span>
										</div>
										<div 
											style={{
												flexShrink: 0,
												display: "flex",
												alignItems: "flex-start",
												background: "linear-gradient(180deg, #6BD0F6, #00AEEF)",
												borderRadius: 6,
												border: `1px solid #00000000`,
												paddingTop: 8,
												paddingBottom: 8,
												paddingLeft: 52,
												paddingRight: 55,
												gap: 4,
											}}>
											<img
												src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/c4bh59d2_expires_30_days.png"} 
												style={{
													width: 15,
													height: 15,
													objectFit: "fill",
												}}
											/>
											<span 
												style={{
													color: "#FFFFFF",
													fontSize: 12,
													fontWeight: "bold",
												}} >
												{"Saved"}
											</span>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div 
							style={{
								width: 1,
								height: 1074,
								background: "#E6E6E6",
							}}>
						</div>
						<div 
							style={{
								flexShrink: 0,
								display: "flex",
								flexDirection: "column",
								alignItems: "flex-start",
								marginTop: 20,
							}}>
							<span 
								style={{
									color: "#979797",
									fontSize: 16,
									fontWeight: "bold",
									marginBottom: 15,
									marginLeft: 23,
								}} >
								{"Library Filters"}
							</span>
							<div 
								style={{
									width: 277,
									height: 1,
									background: "#E6E6E6",
									marginBottom: 16,
									marginLeft: 23,
									marginRight: 23,
								}}>
							</div>
							<span 
								style={{
									color: "#010101",
									fontSize: 16,
									fontWeight: "bold",
									marginBottom: 16,
									marginLeft: 22,
								}} >
								{"Content Type"}
							</span>
							<div 
								style={{
									display: "flex",
									alignItems: "flex-start",
									marginBottom: 16,
									marginLeft: 22,
									marginRight: 22,
								}}>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 14,
										marginRight: 212,
									}} >
									{"Articles"}
								</span>
								<div 
									style={{
										width: 17,
										height: 17,
										background: "#FFFFFF",
										borderRadius: 5,
										border: `1px solid #979797`,
									}}>
								</div>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "flex-start",
									marginBottom: 16,
									marginLeft: 22,
									marginRight: 22,
								}}>
								<span 
									style={{
										color: "#6BD0F6",
										fontSize: 14,
										fontWeight: "bold",
										marginRight: 216,
									}} >
									{"Videos"}
								</span>
								<div 
									style={{
										flexShrink: 0,
										display: "flex",
										flexDirection: "column",
										alignItems: "flex-start",
										background: "linear-gradient(180deg, #6BD0F6, #00AEEF)",
										borderRadius: 5,
										padding: 1,
									}}>
									<img
										src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/yuj3d4sn_expires_30_days.png"} 
										style={{
											width: 15,
											height: 15,
											objectFit: "fill",
										}}
									/>
								</div>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "flex-start",
									marginBottom: 16,
									marginLeft: 22,
									marginRight: 22,
								}}>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 14,
										marginRight: 194,
									}} >
									{"Templates"}
								</span>
								<div 
									style={{
										width: 17,
										height: 17,
										background: "#FFFFFF",
										borderRadius: 5,
										border: `1px solid #979797`,
									}}>
								</div>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "flex-start",
									marginBottom: 27,
									marginLeft: 22,
									marginRight: 22,
								}}>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 14,
										marginRight: 176,
									}} >
									{"Case Studies"}
								</span>
								<div 
									style={{
										width: 17,
										height: 17,
										background: "#FFFFFF",
										borderRadius: 5,
										border: `1px solid #979797`,
									}}>
								</div>
							</div>
							<div 
								style={{
									width: 323,
									height: 6,
									background: "#F1F2F4",
									marginBottom: 29,
								}}>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "flex-start",
									marginBottom: 16,
									marginLeft: 22,
									marginRight: 22,
								}}>
								<span 
									style={{
										color: "#010101",
										fontSize: 16,
										fontWeight: "bold",
										marginRight: 189,
									}} >
									{"Category"}
								</span>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/nyurb3xm_expires_30_days.png"} 
									style={{
										width: 19,
										height: 19,
										objectFit: "fill",
									}}
								/>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "flex-start",
									marginBottom: 16,
									marginLeft: 22,
									marginRight: 22,
								}}>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 14,
										marginRight: 144,
									}} >
									{"Business Strategy"}
								</span>
								<div 
									style={{
										width: 17,
										height: 17,
										background: "#FFFFFF",
										borderRadius: 5,
										border: `1px solid #979797`,
									}}>
								</div>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "flex-start",
									marginBottom: 16,
									marginLeft: 22,
									marginRight: 22,
								}}>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 14,
										marginRight: 145,
									}} >
									{"Marketing & Sales"}
								</span>
								<div 
									style={{
										width: 17,
										height: 17,
										background: "#FFFFFF",
										borderRadius: 5,
										border: `1px solid #979797`,
									}}>
								</div>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "flex-start",
									marginBottom: 16,
									marginLeft: 22,
									marginRight: 22,
								}}>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 14,
										marginRight: 142,
									}} >
									{"Finance & Funding"}
								</span>
								<div 
									style={{
										width: 17,
										height: 17,
										background: "#FFFFFF",
										borderRadius: 5,
										border: `1px solid #979797`,
									}}>
								</div>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "flex-start",
									marginBottom: 16,
									marginLeft: 22,
									marginRight: 22,
								}}>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 14,
										marginRight: 150,
									}} >
									{"Entrepreneurship"}
								</span>
								<div 
									style={{
										width: 17,
										height: 17,
										background: "#FFFFFF",
										borderRadius: 5,
										border: `1px solid #979797`,
									}}>
								</div>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "flex-start",
									marginBottom: 28,
									marginLeft: 22,
									marginRight: 22,
								}}>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 14,
										marginRight: 157,
									}} >
									{"Technology & AI"}
								</span>
								<div 
									style={{
										width: 17,
										height: 17,
										background: "#FFFFFF",
										borderRadius: 5,
										border: `1px solid #979797`,
									}}>
								</div>
							</div>
							<div 
								style={{
									width: 324,
									height: 6,
									background: "#F1F2F4",
									marginBottom: 28,
								}}>
							</div>
							<span 
								style={{
									color: "#010101",
									fontSize: 16,
									fontWeight: "bold",
									marginBottom: 16,
									marginLeft: 22,
								}} >
								{"Popularity & Relevance"}
							</span>
							<div 
								style={{
									display: "flex",
									alignItems: "flex-start",
									marginBottom: 16,
									marginLeft: 22,
									marginRight: 22,
								}}>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 14,
										marginRight: 132,
									}} >
									{"Trending Resources"}
								</span>
								<div 
									style={{
										width: 17,
										height: 17,
										background: "#FFFFFF",
										borderRadius: 5,
										border: `1px solid #979797`,
									}}>
								</div>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "flex-start",
									marginBottom: 16,
									marginLeft: 22,
									marginRight: 22,
								}}>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 14,
										marginRight: 144,
									}} >
									{"Most Downloaded"}
								</span>
								<div 
									style={{
										width: 17,
										height: 17,
										background: "#FFFFFF",
										borderRadius: 5,
										border: `1px solid #979797`,
									}}>
								</div>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "flex-start",
									marginBottom: 16,
									marginLeft: 22,
									marginRight: 22,
									gap: 32,
								}}>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 14,
									}} >
									{"AI-Personalized Recommendations"}
								</span>
								<div 
									style={{
										width: 17,
										height: 17,
										background: "#FFFFFF",
										borderRadius: 5,
										border: `1px solid #979797`,
									}}>
								</div>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "flex-start",
									marginBottom: 16,
									marginLeft: 22,
									marginRight: 22,
								}}>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 14,
										marginRight: 180,
									}} >
									{"Newest First"}
								</span>
								<div 
									style={{
										width: 17,
										height: 17,
										background: "#FFFFFF",
										borderRadius: 5,
										border: `1px solid #979797`,
									}}>
								</div>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "flex-start",
									marginBottom: 24,
									marginLeft: 22,
									marginRight: 22,
								}}>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 14,
										marginRight: 187,
									}} >
									{"Oldest First"}
								</span>
								<div 
									style={{
										width: 17,
										height: 17,
										background: "#FFFFFF",
										borderRadius: 5,
										border: `1px solid #979797`,
									}}>
								</div>
							</div>
							<button 
								style={{
									display: "flex",
									flexDirection: "column",
									alignItems: "flex-start",
									background: "#FFFFFF",
									borderRadius: 8,
									border: `1px solid #00000000`,
									paddingTop: 16,
									paddingBottom: 16,
									paddingLeft: 110,
									paddingRight: 110,
									marginBottom: 8,
									marginLeft: 22,
									marginRight: 22,
									textAlign: "left",
								}}
								onClick={()=>alert("Pressed!")}>
								<span 
									style={{
										color: "#6BD0F6",
										fontSize: 14,
										fontWeight: "bold",
									}} >
									{"Clear"}
								</span>
							</button>
							<button 
								style={{
									display: "flex",
									flexDirection: "column",
									alignItems: "flex-start",
									background: "linear-gradient(180deg, #6BD0F6, #00AEEF)",
									borderRadius: 8,
									border: "none",
									paddingTop: 16,
									paddingBottom: 16,
									paddingLeft: 107,
									paddingRight: 107,
									marginLeft: 22,
									marginRight: 22,
									textAlign: "left",
								}}
								onClick={()=>alert("Pressed!")}>
								<span 
									style={{
										color: "#FFFFFF",
										fontSize: 14,
										fontWeight: "bold",
									}} >
									{"Apply"}
								</span>
							</button>
						</div>
					</div>
				</div>
			</div>
			<Footer/>
		</div>
	)
}